module.exports = __webpack_public_path__ + "media/images/flags/tv-99618ffc3d126b12802f080330a16921.svg";